/* Functions here is to format data display in UI,
 * because "filter" will not support in Vue 3.
 */
import moment from 'moment'
import { SHARED, DATE } from '@/constants'
import i18n from '@/i18n'

export const paginateTableIndex = (value, pageNumber, pageSize = SHARED.DEFAULT_PAGE_SIZE) => {
  let result = ''

  if (typeof value === 'number') {
    result = value + 1 + (pageNumber - 1) * pageSize
  }

  return result < 10 ? '0' + result : result
}

export const getCurrencyFormat = (value, decimalPlaces = 2) => {
  let desc = ''

  if (value != undefined && value != null) {
    desc = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol',
      minimumFractionDigits: decimalPlaces
    }).format(value)
  }

  return desc.replace('$', '')
}

export const getDateFormat = (value) => {
  let desc = ''

  if (value != undefined && value != null && value != '') {
    //Date time format in ISO8601 format 'YYYY-MM-DDTHH:mm:ss.000000Z' mean date time in UTC
    //moment will auto convert it into client timezone
    let dateTimeGMT8 = new Date(value.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
    desc = moment(dateTimeGMT8).format(DATE.SHORT)
  }

  return desc
}

export const getTimeFormat = (value) => {
  let desc = ''

  if (value != undefined && value != null && value != '') {
    //Date time format in ISO8601 format 'YYYY-MM-DDTHH:mm:ss.000000Z' mean date time in UTC
    //moment will auto convert it into client timezone
    let dateTimeGMT8 = new Date(value.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
    desc = moment(dateTimeGMT8).format(DATE.TIME)
  }

  return desc
}

export const getDateTimeFormat = (value) => {
  let desc = ''

  if (value != undefined && value != null && value != '') {
    //Date time format in ISO8601 format 'YYYY-MM-DDTHH:mm:ss.000000Z' mean date time in UTC
    //moment will auto convert it into client timezone
    let dateTimeGMT8 = new Date(value.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
    desc = moment(dateTimeGMT8).format(DATE.LONG)
  }

  return desc
}

export const getActivationStatus = (value) => {
  let desc = ''

  if (typeof value === 'number') {
    desc = i18n.t(`enumActivationStatus[0].${value}`)
  } else if (typeof value === 'boolean') {
    desc = i18n.t(`enumActivationStatus[1].${value}`)
  } else if (typeof value === 'string' && value != '') {
    desc = i18n.t(`enumActivationStatus[2].${value.toLowerCase()}`)
  }

  return desc
}
